import { render, staticRenderFns } from "./file-list-item.vue?vue&type=template&id=208aa507"
import script from "./file-list-item.vue?vue&type=script&lang=js"
export * from "./file-list-item.vue?vue&type=script&lang=js"
import style0 from "./file-list-item.vue?vue&type=style&index=0&id=208aa507&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports